import React from 'react';
import Typography from '@mui/material/Typography';
import {grey, pink, purple, blue, teal, green, orange, lightGreen, red} from '@mui/material/colors';
import moment from 'moment';

const verformats:any = {
  REQUESTED:{text:'REQUESTED',color:'default',scolor:grey[500]},
  ACCESSED:{text:'ACCESSED',color:'default',scolor:pink[500]},
  UPLOADED:{text:'PENDING',color:'secondary',scolor:purple[500]},
  PROCESSED:{text:'PENDING',color:'secondary',scolor:blue[500]},
  SUBMITTED:{text:'PROCESSING',color:'primary',scolor:teal[500]},
  AUTOPASSED:{text:'PASSED',color:'primary',scolor:green[500]},
  AUTOFAILED:{text:'PROCESSING',color:'secondary',scolor:orange[500]},
  MANUALPASSED:{text:'PASSED',color:'primary',scolor:lightGreen[500]},
  MANUALFAILED:{text:'FAILED',color:'error',scolor:red[500]},
  DISABLED:{text:'CLOSED',color:'default',scolor:grey[800]},
  DEFAULT:{text:'ERROR',color:'default',scolor:'black'}
};

const getvformat = (stn:string) => verformats[stn]||verformats.DEFAULT;

const ftformats:any = {
  REQUESTED:{text:'REQUESTED',color:'default',scolor:grey[500]},
  ACCESSED:{text:'ACCESSED',color:'default',scolor:pink[500]},
  UPLOADED:{text:'UPLOADED',color:'secondary',scolor:purple[500]},
  PROCESSED:{text:'PROCESSED',color:'primary',scolor:blue[500]},
  SUBMITTED:{text:'SUBMITTED',color:'primary',scolor:teal[500]},
  PENDING:{text:'PENDING',color:'secondary',scolor:purple[500]},
  PASSED:{text:'PASSED',color:'primary',scolor:green[500]},
  FAILED:{text:'FAILED',color:'secondary',scolor:orange[500]},
  SUCCESS:{text:'SUCCESS',color:'primary',scolor:lightGreen[500]},
  FAILURE:{text:'FAILED',color:'secondary',scolor:red[500]},
  ERROR:{text:'ERROR',color:'error',scolor:red[500]},
  DISABLED:{text:'CLOSED',color:'default',scolor:grey[800]},
  DEFAULT:{text:'ERROR',color:'default',scolor:'black'}
};

const getftformat = (key:string) => ftformats[key]||ftformats.DEFAULT;

const arrayformats = [
  {text:'',color:'default',scolor:grey[500]},
  {text:'',color:'default',scolor:pink[500]},
  {text:'',color:'secondary',scolor:purple[500]},
  {text:'',color:'primary',scolor:blue[500]},
  {text:'',color:'primary',scolor:teal[500]},
  {text:'',color:'secondary',scolor:purple[500]},
  {text:'',color:'primary',scolor:green[500]},
  {text:'',color:'secondary',scolor:orange[500]},
  {text:'',color:'primary',scolor:lightGreen[500]},
  {text:'',color:'secondary',scolor:red[500]},
  {text:'',color:'error',scolor:red[500]},
  {text:'',color:'default',scolor:grey[800]},
];
const arraydefault = {text:'UNKNOWN',color:'default',scolor:'black'};

const getarrayformat = (key:number) => arrayformats[key]||arraydefault;

const formatDate = (id:any) => {  //id must be isostamp
  return moment(id).format('DD-MMM-YYYY HH:mm');
}

//.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
const formatMoney = (amt:any) => {  //amt must be numeric
  if(!amt) return '';
  const options = { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  };
  return Number(amt).toLocaleString('en', options);
  //w.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+;
}

const formatGender = (id:number) => {
  let text = ['Female','Male'][id] || 'unknown';
  let color:any = ['secondary','primary'][id] || 'inherit';
  let rtn = (<Typography color={color}>{text}</Typography>);
  return rtn;
}

const formatStatus = (id:number) => {
  let text = ['Disabled','Active'][id] || 'unknown';
  let color:any = ['secondary','primary'][id] || 'inherit';
  let rtn = (<Typography color={color}>{text}</Typography>);
  return rtn;
}

const loginStatus = (id:number,rec:any) => {
  let text = ['Disabled','Active','Suspended'][id] || id;
  let color:any = ['default','primary','secondary'][id] || 'inherit';
  let rtn = (<Typography color={color}>{text}</Typography>);
  return rtn;
}

const simpleStatus = (id:number,rec:any) => {
  let name = ['disabled','active','stopped'][id] || 'unknown'; 
  return name;
}

const requestStatus = (id:number,rec:any) => {
  let fmt = getvformat(rec.stn);
  let rtn = (<Typography color={fmt.color}>{fmt.text}</Typography>);
  return rtn;
}

const reviewStatus = (id:number,rec:any) => {
  let fmt = getvformat(rec.stn);
  let rtn = (<Typography style={{color:fmt.scolor}}>{rec.stn}</Typography>);
  return rtn;
}

const formatSource = (id:number,rec:any) => {
  if(rec.dsc === "") return null;
  var it = JSON.parse(rec.dsc) || {};
   return it.src||'None';
}

const txnStatus = (key:any) => {
  let fmt = getftformat(key);
  let rtn = (<Typography style={{color:fmt.scolor}}>{fmt.text}</Typography>);
  return rtn;
}

const arrayStatus = (id:string,txt:any) => {
  let fmt = getftformat(id);
  let rtn = (<Typography style={{color:fmt.scolor}}>{txt}</Typography>);
  return rtn;
}

export {formatDate,formatMoney,formatGender,formatStatus,loginStatus,simpleStatus,requestStatus,reviewStatus,txnStatus,arrayStatus,formatSource};


export default {stp:formatDate,sts:formatStatus,src:formatSource};



//SPEC TO download logo once and store;
// createImageBitmap??
// createElement(image)
// image.onload => {
//   readas dataurl
// }
// set image src 
